import { useState } from "react"
import MainTitle from "../MainTitle"
import NewsCard from "./NewsCard"
import { useNewsListQuery } from "@/service/api/news"
import type { ListRequest } from "@/shared/types/commonResponse"
import { STAR_ID } from "@/shared/constants/star"
import NewsSkeleton from "@/components/skeleton/news/news-list-skeleton"

const News = () => {
  const [newsList, setNewsList] = useState<ListRequest>({
    Language: "en",
    angkorId: "",
    requestDto: {
      pageable: {
        page: 0,
        size: 3,
        sort: [],
      },
      searchKeyword: "",
      starId: STAR_ID,
    },
  })

  const { data: newsListData = { content: [] }, isLoading } =
    useNewsListQuery(newsList)

  const noContent = newsListData.content.length === 0

  return (
    <>
      {!noContent && (
        <div className="mb-5">
          <MainTitle title="News" link="news" />
          <div className="px-4">
            {isLoading ? (
              <NewsSkeleton />
            ) : (
              newsListData.content.map((item) => (
                <NewsCard
                  key={item.id}
                  id={item.id}
                  title={item.title}
                  date={item.regDt}
                  image={item.thumbImageUrl}
                />
              ))
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default News
